module.exports = __webpack_public_path__ + "img/Advantage_icon02.296fae39.png";